export default __webpack_public_path__ + "static/media/black-mockup-winner.07c9ddd7.png";